import React from 'react';
import ServiceLevelAgreementsAdminTable from './components/ServiceLevelAgreementsAdminTable';
import { EditSlaProvider } from './hooks/EditSlaContext';

import CreateServiceLevelAgreementModal from './components/CreateServiceLevelAgreementModal';

const ServiceLevelAgreementsAdmin = ({ showCreateModal, setShowCreateModal }) => {

    return <React.Fragment>
            <CreateServiceLevelAgreementModal 
                show={showCreateModal}
                handleClose={() => setShowCreateModal(false)}
            />
            <EditSlaProvider>
                <ServiceLevelAgreementsAdminTable />
            </EditSlaProvider>
        </React.Fragment>
}

export default ServiceLevelAgreementsAdmin;